import React, { forwardRef } from 'react';

import PropTypes from 'prop-types';
import { View } from '@fairygodboss/ui';

import { ApplyButtonGroup } from './ApplyButtonGroup';

export const ApplyBottom = forwardRef(
    ({ handleSaveClick, isSaved, handleCompanyApplyClick }, ref) => {
        return (
            <View pt={{ _: '16px', sm: 'large' }} ref={ref}>
                <ApplyButtonGroup
                    handleSaveClick={handleSaveClick}
                    isSaved={isSaved}
                    handleCompanyApplyClick={handleCompanyApplyClick}
                    position="bottom"
                />
            </View>
        );
    }
);

ApplyBottom.propTypes = {
    handleSaveClick: PropTypes.func,
    isSaved: PropTypes.bool,
    handleCompanyApplyClick: PropTypes.func,
};

ApplyBottom.defaultProps = {
    handleSaveClick: () => {},
    isSaved: false,
    handleCompanyApplyClick: () => {},
};
